import type { ConnectionStatus } from '../types';

interface StatusHUDProps {
  status: ConnectionStatus;
  isSpeaking: boolean;
}

const STATUS_LABEL: Record<ConnectionStatus, string> = {
  connecting:   'CONECTANDO...',
  connected:    'ONLINE',
  disconnected: 'DESCONECTADO',
  error:        'ERROR DE CONEXIÓN',
};

const STATUS_COLOR: Record<ConnectionStatus, string> = {
  connecting:   '#f59e0b',
  connected:    '#00ffcc',
  disconnected: '#ef4444',
  error:        '#ef4444',
};

export default function StatusHUD({ status, isSpeaking }: StatusHUDProps) {
  const label = isSpeaking ? 'HABLANDO...' : STATUS_LABEL[status];
  const color = isSpeaking ? '#00ffcc' : STATUS_COLOR[status];

  return (
    <div className="hud-overlay">
      <h1 className="hud-title">RAMMUX.SYS</h1>
      <p className="hud-status">
        ESTADO:{' '}
        <span style={{ color, transition: 'color 0.3s' }}>{label}</span>
      </p>
      <p className="hud-sub">NÚCLEO NEURONAL ACTIVO</p>
    </div>
  );
}
